import ToastNotification from 'components/molecules/ToastNotification';

export const toastHelper = {
  successNotification: (message: string) => {
    ToastNotification.success(message.split(/(?:<br\/>|<br>|<\/br>|<br \/>)/g).join('\n'));
  },
  errorNotification: (message: string) => {
    ToastNotification.error(message.split(/(?:<br\/>|<br>|<\/br>|<br \/>)/g).join('\n'));
  },
  warningNotification: (message: string) => {
    ToastNotification.warning(message.split(/(?:<br\/>|<br>|<\/br>|<br \/>)/g).join('\n'));
  },
};

const useToastNotification = () => ({
  successNotification: (message: string) => {
    ToastNotification.success(message.split(/(?:<br\/>|<br>|<\/br>|<br \/>)/g).join('\n'));
  },
  errorNotification: (message: string) => {
    ToastNotification.error(message.split(/(?:<br\/>|<br>|<\/br>|<br \/>)/g).join('\n'));
  },
  warningNotification: (message: string) => {
    ToastNotification.warning(message.split(/(?:<br\/>|<br>|<\/br>|<br \/>)/g).join('\n'));
  },
});

export default useToastNotification;
